export default function popupAlertText() {
  const content = $('#popupAlertText__modal');
  const prosseguir = $('#popupAlertText__modal .closeMyModal');
  const prosseguir_a = $('#popupAlertText__modal a');

  if (localStorage.getItem('popupAlertText')) {
    content.hide();
  } else {
    content.css('display', 'flex');
  }

  prosseguir.click(() => {
    content.hide();
    localStorage.setItem('popupAlertText', true);
  });
  prosseguir_a.click(() => {
    content.hide();
    localStorage.setItem('popupAlertText', true);
  });
}